import { AcceptItem } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const submitAcceptedItem: (
  fetchContext: FetchContext,
  userId: number,
  acceptItem: AcceptItem,
  accessToken?: string) => Promise<void> = async (fetchContext, userId, acceptItem, accessToken) => {
  const acceptItemBody = { acceptItemId: acceptItem.acceptItemId };
  
  return fetch(`${fetchContext.baseUrl}/api/users/${userId}/accept-item-refs`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(acceptItemBody),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'submit accepted item'));
};
